import React, { useState, forwardRef, useImperativeHandle } from 'react';
import * as rsuite from "rsuite";
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import axios from 'axios';
import TaskHistory from './TaskHistory';

// نمایش جزئیات وظیفه - فقط برچسب و مقدار، بدون هیچ ورودی.
//
// عمدا از TaskProp جدا است: یک فرم غیرفعال هنوز شبیه فرم است و کاربر
// انتظار دارد بتواند چیزی را عوض کند. اینجا از اول خواندنی است.

const Field = ({ label, children }) => (
    <div style={{ display: 'flex', gap: 10, padding: '7px 0', borderTop: '1px solid #e6e9ed' }}>
        <span style={{ color: '#8c97a3', fontSize: 12, minWidth: 96 }}>{label}</span>
        <span style={{ fontSize: 13 }}>{children}</span>
    </div>
);

const TaskDetail = forwardRef((props, ref) => {

    //#region const
    const [Task, setTask] = useState(null);
    const [ShowLoader, setShowLoader] = useState(false);
    //#endregion

    //#region Methods

    useImperativeHandle(ref, () => ({
        Show(Id) {
            setTask(null);
            setShowLoader(true);
            var RequestOption = {
                method: 'Get',
                url: General.ApiRoute() + "/Task/GetById",
                headers: {
                    ApiKey: process.env.REACT_APP_APIKEY,
                    Id: Id
                },
                withCredentials: true
            }
            axios(RequestOption)
                .then(function (res) {
                    setTask(res.data);
                    setShowLoader(false);
                })
                .catch(error => {
                    setShowLoader(false);
                    if (error.response) {
                        if (error.response.status === 401) {
                            General.ShowMsg(Enum.MsgType.error, General.unAuthorize());
                        }
                        else if (error.response.status === 403) {
                            General.ShowMsg(Enum.MsgType.error, General.AccessDenied());
                        }
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                    }
                })
        }
    }))
    //#endregion

    if (ShowLoader) {
        return (
            <div style={{ padding: 30, textAlign: 'center' }}>
                <rsuite.Loader content="در حال دریافت اطلاعات..." />
            </div>
        );
    }

    if (Task === null) {
        return null;
    }

    //--> دلیل برگشت را از تاریخچه بر می داریم، نه از یک ستون جدا: GetById
    //--> همه وضعیت ها را با توضیحشان بر می گرداند. فقط تا وقتی وظیفه هنوز
    //--> برگشت خورده است بالا نشان داده می شود؛ بعد از شروع دوباره، تاریخ است.
    const rejected = Task.state === Enum.TaskStateType.Rejected && Task.states
        ? [...Task.states].reverse().find(x => x.state === Enum.TaskStateType.Rejected && x.comment)
        : null;

    return (
        <div>
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 10 }}>{Task.title}</div>

            {
                rejected ?
                    <rsuite.Message type="error" showIcon className='mb-2'>
                        دلیل برگشت: {rejected.comment}
                    </rsuite.Message>
                    :
                    null
            }

            <Field label="وضعیت">{Task.stateComment}</Field>
            <Field label="مسئول انجام">
                {
                    Task.assignToFullName ?
                        Task.assignToFullName
                        :
                        <rsuite.Tag color="orange">انتساب داده نشده</rsuite.Tag>
                }
            </Field>
            <Field label="پروژه">{Task.projectTitle} · {Task.categoryTitle}</Field>
            <Field label="اولویت">{Task.priorityComment}</Field>
            <Field label="مهلت انجام">
                {
                    Task.isOverdue ?
                        <rsuite.Tag color="red">{Task.dueDate}</rsuite.Tag>
                        :
                        Task.dueDate
                }
            </Field>
            <Field label="تعریف شده توسط">{Task.sourceComment}</Field>
            <Field label="ثبت کننده">{Task.creatorFullName}</Field>
            <Field label="تاریخ ثبت">{Task.createDate} - {Task.createTime}</Field>
            {
                Task.ticketNumber ?
                    <Field label="تیکت مرتبط">{Task.ticketNumber}</Field>
                    :
                    null
            }

            {
                Task.description ?
                    <>
                        <rsuite.Divider>شرح کار</rsuite.Divider>
                        <div style={{ fontSize: 13, whiteSpace: 'pre-wrap', lineHeight: '26px' }}>
                            {Task.description}
                        </div>
                    </>
                    :
                    null
            }

            <TaskHistory states={Task.states} />
        </div>
    );
});

export default TaskDetail;
